module.exports = __webpack_public_path__ + "a570d239fef2b6ef6defab62d64ece65.pdf";